// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__o+c-A","image":"style_image__X9O3y"};